import React from 'react';

const Currency = props => {
  const { children, digits = 2 } = props;
  const formattedNumber = new Intl.NumberFormat('en', {
    style: 'decimal',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(children);
  
  return (
    <span>{typeof children === 'number' && formattedNumber}</span>
  );
};

export default Currency;